import { z } from 'zod';
import { localizedTextSchema, optionalLocalizedTextSchema } from './localized';

export const groupInvoiceAdjustmentSchema = z.object({
  type: z.literal('add_line'),
  articleNumber: z.string().trim().min(1),
  description: localizedTextSchema,
  amount: z
    .string()
    .trim()
    .regex(/^[+-]?\d+([.,]\d{1,2})?$/),
});

export const groupSchema = z.object({
  id: z.string().uuid().optional(),
  projectId: z.string().uuid(),
  name: localizedTextSchema,
  packagePrice: z.coerce.number().nonnegative('Pakketprijs moet positief zijn'),
  singleRoomSupplement: z.coerce.number().nonnegative().optional(),
  invoiceDescription: optionalLocalizedTextSchema,
  depositDescription: optionalLocalizedTextSchema,
  invoiceRemark: optionalLocalizedTextSchema,
  invoiceAdjustments: z.array(groupInvoiceAdjustmentSchema).optional(),
  isActive: z.boolean().default(true),
});

export const createGroupSchema = groupSchema.omit({ id: true });
export const updateGroupSchema = groupSchema.partial().omit({ id: true });

export type GroupFormData = z.infer<typeof createGroupSchema>;
export type GroupSchema = z.infer<typeof groupSchema>;
export type GroupInvoiceAdjustment = z.infer<typeof groupInvoiceAdjustmentSchema>;
